import { StyleConfig } from '@chakra-ui/styled-system';
import { rem } from '../../utils/utils';

const SelectTheme: StyleConfig = {
  baseStyle: ({ hasStateIcon, isPlaceholderShown }) => ({
    field: {
      appearance: 'none',
      background: 'background/primary',
      border: '1px solid',
      borderColor: 'border/strong',
      borderRadius: '4',
      color: isPlaceholderShown ? 'input/text/placeholder' : 'input/text/inputValue',
      cursor: 'pointer',
      position: 'relative',
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingRight: hasStateIcon ? '64' : '40',
      _hover: {
        borderColor: 'border/hover',
      },
      _disabled: {
        background: 'background/disabled',
        borderColor: 'border/disabled',
        cursor: 'not-allowed',
        color: 'text/disabled',
      },
      _invalid: {
        borderColor: 'border/error',
      },
      _readOnly: {
        cursor: 'default',
      },
    },
    icon: {
      color: 'icon/secondary',
      right: rem(11),
      _groupHover: {
        color: 'icon/primary',
        _disabled: {
          color: 'icon/on-disabled',
        },
      },
      _disabled: {
        color: 'icon/on-disabled',
      },
    },
    selectContainer: {
      position: 'relative',
    },
    stateIcon: {
      position: 'absolute',
      right: rem(42),
      top: '50%',
      transform: 'translateY(-50%)',
      pointerEvents: 'none',
    },
  }),
  sizes: {
    lg: {
      field: {
        fontSize: '3',
        gap: '0.625rem',
        height: '48',
        paddingLeft: rem('15'),
      },
    },
    md: {
      field: {
        fontSize: '2',
        gap: '0.375rem',
        height: '40',
        paddingLeft: rem('11'),
      },
    },
  },
};

export default SelectTheme;
